export var organizers = [
	{
		name: "Prof. Dr. Gerhard P. Fettweis",
		affiliation: "TU&nbsp;Dresden /<br>Barkhausen Institut",
		portrait: "GerhardFettweis.jpg",
		role: "General<br>Co-Chair",
	},
	{
		name: "Prof. Dr. Thomas Ußmüller",
		affiliation: "Universität Innsbruck",
		portrait: "ussmueller.jpg",
		role: "General<br>Co-Chair",
	},
	{
		name: "André Bourdoux",
		affiliation: "IMEC",
		portrait: "AndreBourdoux.jpg",
		role: "TPC<br>Co-Chair",
	},
	{
		name: "Dr. Fan Liu",
		affiliation: "SUSTech",
		portrait: "Fan_Liu.jpg",
		role: "TPC<br>Co-Chair",
	},
	{
		name: "Carolin Bauder",
		affiliation: "TU&nbsp;Dresden",
		portrait: "CarolinBauder.jpg",
		role: "Organizing<br>Chair",
	},
	{
		name: "Dr. Rico Radeke",
		affiliation: "TU&nbsp;Dresden",
		portrait: "RicoRadeke.jpg",
		role: "Finance<br>Chair",
	},
	{
		name: "Dominik Mair",
		affiliation: "Universität Innsbruck",
		portrait: "DominikMair.jpg",
		role: "Local&nbsp;Arrangements<br>Chair",
	},
	{
		name: "Dr. André Noll Barreto",
		affiliation: "Barkhausen Institut",
		portrait: "nollbarreto.jpg",
		role: "Publication<br>Chair",
	},
	{
		name: "Dr. Padmanava Sen",
		affiliation: "Barkhausen Institut",
		portrait: "sen.jpg",
		role: "Keynotes&nbsp;&&nbsp;Panels<br>Co-Chair",
	},
	{
		name: "Dr. Ahmad Nimr",
		affiliation: "TU Dresden",
		portrait: "AhmadNimr.jpg",
		role: "Keynotes&nbsp;&&nbsp;Panels<br>Co-Chair",
	},
	{
		name: "Daniel Swist",
		affiliation: "TU Dresden",
		portrait: "DanielSwist.jpg",
		role: "Technical&nbsp;Arrangements<br>Co-Chair"
	},

	{
		name: "Georg Saxl",
		affiliation: "Universität Innsbruck",
		portrait: "GeorgSaxl.jpg",
		role: "Technical&nbsp;Arrangements<br>Co-Chair"
	},

	// {
	// 	name: "Francisco Arroyo",
	// 	affiliation: "5G Lab Germany",
	// 	portrait: "francisco_arroyo.jpg",

	// },

	{
		name: "Fabian Diehm",
		affiliation: "TU&nbsp;Dresden",
		portrait: "fabian_diehm.jpg",
		role: "Web<br>Chair",
	},

];
